import { render } from "./MoaAndAgreements.vue?vue&type=template&id=0752be5d"
import script from "./MoaAndAgreements.vue?vue&type=script&lang=js"
export * from "./MoaAndAgreements.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__